
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FiltersConfiguration } from '@/helpers/ColorModule/ColorModuleHelper';

@Component({
    name: 'MandatoryColorModuleFilters',
    components: {},
})
export default class MandatoryColorModuleFilters extends Vue {
    @Prop({ required: true }) private filters!: any;
    @Prop({ required: true }) private activeTab!: string;
    @Prop({ required: true }) private requestFiltersActive!: boolean;
    @Prop({ required: false, default: false }) private showLatestColors!: boolean;

    private get FiltersConfiguration(): any {
        return FiltersConfiguration.filter((filter) => filter.isMandatory && filter.isActive(this.activeTab));
    }

    private isFilterDisabled(filter: any): boolean {
        const isFilterActive = filter.isActive(this.activeTab);
        const isColorTableActive = this.activeTab === 'color-search';
        const isShowingLatestColors = this.showLatestColors;

        return !isFilterActive || (isShowingLatestColors && isColorTableActive);
    }

    private onFilterChange(value: string, type: string, option: any) {
        this.$emit('filterChange', { value, type, id: option?.key || '' });
    }
}
